var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgColorPicker = function SvgColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.323 10.87 8.06 6.135l2.814 2.819-4.736 4.749c-.071.069-.148.133-.228.19l-.054.038a2.1 2.1 0 0 1-.208.125h-.095c-.12.058-.247.1-.378.128h-.046l-.153.021h-.067a1.352 1.352 0 0 0-.415.12c-.169.08-.32.192-.448.328l-1 .997a1.217 1.217 0 0 1-1.711 0 1.216 1.216 0 0 1 0-1.71l.996-.997c.137-.127.248-.28.328-.448.062-.131.103-.271.12-.415v-.067c0-.02 0-.104.021-.154v-.045c.028-.132.07-.26.13-.382v-.096c.036-.071.078-.14.124-.207l.037-.054c.072-.074.15-.142.232-.204ZM16.313.704a2.4 2.4 0 0 1 0 3.396l-2.33 2.333.378.377a.664.664 0 0 1 0 .939l-1.005 1.004a.664.664 0 0 1-.938 0l-4.15-4.151a.664.664 0 0 1 0-.938l1-1.005a.664.664 0 0 1 .938 0l.378.378L12.917.704a2.4 2.4 0 0 1 3.395 0Z"
  })));
};

export default SvgColorPicker;